import { VerifyOobaTokenInput } from '../../gql/graphql';
import authService from '../../services/auth.service';

export enum TokenErrors {
  Invalid = 'invalid',
  Expired = 'expired',
}

/**
 * Attempts to verify the supplied token
 * @param input - The token to verify
 * @returns - a boolean indaticating whether or not the token is valid
 */
const verifyOobaToken = async (input: VerifyOobaTokenInput): Promise<[boolean, TokenErrors | null]> => {
  try {
    const { data, errors } = await authService.verifyOobaToken(input);

    if (errors) {
      // OOBA token must be valid skip IDV
      console.error(errors);
      return [false, TokenErrors.Invalid];
    }

    if (data?.verifyOobaToken?.verifyOobaTokenErrors?.length) {
      // OOBA token must be valid skip IDV
      console.error(data.verifyOobaToken.verifyOobaTokenErrors);
      if (data.verifyOobaToken.verifyOobaTokenErrors.some((e) => e.__typename === 'ExpiredToken')) {
        return [false, TokenErrors.Expired];
      }

      return [false, TokenErrors.Invalid];
    }

    return [true, null];
  } catch (e) {
    // OOBA token must be valid to skip IDV
    console.error(e);
    return [false, TokenErrors.Invalid];
  }
};

export default verifyOobaToken;
